import Section from "../components/AboutUs/Section";
import Team from "../components/AboutUs/Team";
import WhatWe from "../components/AboutUs/WhatWe";

export default function AboutUs (){
  return (

  <> 
   
    
    <Section/>
    <Team/>
    <WhatWe/>
  </>

 )
}